import {Box, Button, ButtonGroup, Flex, HStack, Text} from '@chakra-ui/react';
import React from 'react';
import {atom, useRecoilState} from 'recoil';
import {BsFillGridFill} from 'react-icons/bs';
import {FaList} from 'react-icons/fa';
import Container from "../../../components/Container";

const companyViewState = atom({
    key: 'teambio-nav__view',
    default: 'grid',
});

const PortfolioNav = () => {
    const [view, setView] = useRecoilState(companyViewState);

    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Box position={'relative'}>
                    <Container>
                        <Box pb={[view === 'grid' ? '30px' : '5px', '33px']} as="section">
                            <Box as="nav">
                                <Flex px={['2.5', '5']} justify="space-between" wrap={'wrap'}>
                                    <Text as={'h1'} lineHeight={'2rem'} fontSize={'2rem'}>
                                        Investments
                                    </Text>
                                    <HStack spacing="2">
                                        <ButtonGroup>
                                            <Button
                                                iconSpacing={0}
                                                size={'xs'}
                                                leftIcon={<BsFillGridFill/>}
                                                variant={'brand'}
                                                borderRadius={'full'}
                                                colorScheme={'brand'}
                                                isActive={view === 'grid'}
                                                onClick={() => setView('grid')}
                                            />
                                            <Button
                                                iconSpacing={0}
                                                size={'xs'}
                                                leftIcon={<FaList/>}
                                                variant={'brand'}
                                                borderRadius={'full'}
                                                colorScheme={'brand'}
                                                onClick={() => setView('list')}
                                                isActive={view === 'list'}
                                            />
                                        </ButtonGroup>
                                    </HStack>
                                </Flex>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default PortfolioNav;
export {companyViewState};
